export const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

export const isValidDateStr = (dateStr?: string) => {
  return (
    (dateStr &&
      dateStr.match(dateRegex) &&
      new Date(dateStr).toString() !== 'Invalid Date' &&
      !isNaN(Date.parse(dateStr))) ||
    false
  );
};

const getAgeFromBirthDate = (dateStr: string) => {
  const today = new Date();
  const birthDate = new Date(dateStr);
  const age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();

  return m < 0 || (m === 0 && today.getDate() < birthDate.getDate()) ? age - 1 : age;
};

export const isValidAge = (dateStr: string, ageBounds?: { minAge?: number; maxAge?: number }) => {
  if (!dateStr.match(dateRegex)) return { message: 'Invalid date' };

  const age = getAgeFromBirthDate(dateStr);
  const { minAge, maxAge } = { minAge: 13, maxAge: 120, ...ageBounds };

  if (minAge && age < minAge) {
    return { message: `You must be over ${minAge} years old to use Buoy` };
  }

  if (maxAge && age > maxAge) {
    return { message: 'Please correct your birthday to continue' };
  }

  return { valid: true };
};

export const validateBirthday = (dateStr?: string) => {
  if (!dateStr || !isValidDateStr(dateStr)) return 'Invalid date';

  const { valid, message } = isValidAge(dateStr);

  return valid || message;
};

export const maskBirthday = (dateStr: string) => {
  if (!dateStr) return '';

  const unmaskedDate = dateStr.replace(/\//g, '');
  let monthStr = unmaskedDate.slice(0, 2);
  let dayStr = unmaskedDate.slice(2, 4);
  let yearStr = unmaskedDate.slice(4, 8);

  if (parseInt(monthStr, 10) > 12) {
    yearStr = `${dayStr.slice(1, 2)}${yearStr.slice(0, 3)}`;
    dayStr = `${monthStr.slice(1, 2)}${dayStr.slice(0, 1)}`;
    monthStr = `0${monthStr.slice(0, 1)}`;
  } else if (parseInt(monthStr, 10) > 1) {
    monthStr = monthStr.padStart(2, '0');
  }

  if (parseInt(dayStr, 10) > 31) {
    yearStr = `${dayStr.slice(1, 2)}${yearStr.slice(0, 3)}`;
    dayStr = `0${dayStr.slice(0, 1)}`;
  } else if (parseInt(dayStr, 10) > 3) {
    dayStr = `${dayStr.padStart(2, '0')}`;
  }

  return `${monthStr}${dayStr ? '/' : ''}${dayStr || ''}${yearStr ? '/' : ''}${yearStr}`;
};
